import fetch from '../../utils/fetch'

export function pay(params) {
    return fetch({
        url: '/api/pay/unionOrder',
        method: 'POST',
        data: params
    })
}
export function yddPay(params) {
    return fetch({
        url: '/api/jtbarcodePay/yddPay',
        method: 'POST',
        data: params
    })
}
export function prepaidSettlement(params) {
    return fetch({
        url: '/api/userCoupon/prepaidSettlement',
        method: 'POST',
        data: params
    })
}

export function payTest(params) {
    return fetch({
        url: '/api/icbcBank/PayTest',
        method: 'POST',
        data: params
    })
}
//修改订单
export function updateBySn(params) {
    return fetch({
        url: '/api/order/updateBySn',
        method: 'POST',
        data: params
    })
}
